import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@thegoodbandit.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("gb_admin_token", data.token);
      localStorage.setItem("gb_admin_email", data.email);
      toast.success("Welcome.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally { setBusy(false); }
  };

  return (
    <main data-testid="admin-login-page" className="bg-black min-h-screen flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="w-full max-w-md border border-white/10 p-10 noise">
        <Lock size={20} className="text-[var(--gb-gold)] mb-6" />
        <p className="overline mb-3">Good Bandit · Admin</p>
        <h1 className="font-display text-4xl text-white mb-8">Studio access</h1>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="kbd block mb-2">EMAIL</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="gb-input" required />
          </div>
          <div>
            <label className="kbd block mb-2">PASSWORD</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="gb-input" required />
          </div>
          <button data-testid="admin-login-submit" disabled={busy} className="gb-btn-primary w-full justify-center">
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </motion.div>
    </main>
  );
}
